import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default ({
    namespaced: true,

    state: {
        comunicaciones: [],
    },
    getters: {
        comunicaciones(state) {
            return state.comunicaciones
        }
    },
    mutations: {
        setComunicaciones(state, payload) {
            state.comunicaciones = payload
        }
    },
    actions: {
        //POST-> portal/comunicaciones/obtenerComunicaciones
        async obtenerComunicaciones({ commit, dispatch }, payload) {
            await axios({
                method: 'post',
                url: process.env.VUE_APP_API + 'portal/comunicaciones/obtenerComunicaciones',
                withCredentials: false,
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                },
                data: payload,
            })
                .then((response) => {
                    const res = response.data
                    commit('setComunicaciones', res.comunicaciones)
                })
                .catch((error) => {
                    console.log(error)
                    return error.response.data
                }).finally(() => {
                    dispatch('auth/setSktLoader', false, { root: true })
                });
        }
    },
})